import { ctx } from './ctx.js';
import { wf } from './state.js';
import { apiGet } from './api.js';
import { TBL_SHEET, TBL_BIM } from './constants.js';
import { getFirst, sectionKey, isNodeCollapsed } from './utils.js';
import { buildSectionNode } from './builders.js';

export function loadProjectSheets(cb) {
  if (ctx.projSheetCache !== null) { if (cb) cb(); return; }
  ctx.projSheetCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID from Project},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula)
    + '&fields[]=Sheet+Number+and+Title&fields[]=Sheet+Progress&fields[]=Sheet+Sort+Order'
    + '&sort[0][field]=Sheet+Sort+Order&sort[0][direction]=asc&maxRecords=200';
  apiGet(TBL_SHEET, qs, function(d) {
    ctx.projSheetCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('production');
  });
}

export function loadBim(cb) {
  if (ctx.bimCache !== null) { if (cb) cb(); return; }
  ctx.bimCache = [];
  var formula = 'FIND("' + ctx.recordId + '",ARRAYJOIN({Project Record UID (from Project)},","))';
  var qs = 'filterByFormula=' + encodeURIComponent(formula)
    + '&fields[]=Name&fields[]=Status&fields[]=Sort+Order+(from+BIM+System+Template)&sort[0][field]=Sort+Order+(from+BIM+System+Template)&sort[0][direction]=asc&maxRecords=100';
  apiGet(TBL_BIM, qs, function(d) {
    ctx.bimCache = d ? d.records : [];
    if (cb) cb();
    ctx.refreshRootChildren('production');
    if (ctx.bimCache !== null) {
      var allMsKeys = Object.keys(wf.collapsed);
      for (var bk = 0; bk < allMsKeys.length; bk++) {
        if (allMsKeys[bk].indexOf('ms:') === 0 && wf.collapsed[allMsKeys[bk]] === false) {
          var _bmsId = allMsKeys[bk].replace('ms:', '');
          (function(bmsId) {
            if (ctx.bimCache && ctx.bimCache.length > 0) {
              ctx.refreshSection(bmsId, 'bim', function() {
                var h = '';
                for (var i = 0; i < ctx.bimCache.length; i++) h += buildBimRow(ctx.bimCache[i]);
                return buildSectionNode(bmsId, 'bim', 'BIM Systems', h, ctx.bimCache.length);
              });
            } else {
              var _bEl = document.querySelector('.wf-node[data-key="' + sectionKey(bmsId, 'bim') + '"]');
              if (_bEl) _bEl.parentNode.removeChild(_bEl);
            }
          })(_bmsId);
        }
      }
    }
  });
}

export function buildBimRow(item) {
  var f = item.fields;
  var name = f['Name'] || 'BIM System';
  var status = f['Status'] || '';
  var statusColor = status.indexOf('Complete') !== -1 ? '#1D9E75' : status.indexOf('No ') !== -1 ? '#c0392b' : '#7a9aaa';
  var h = '<div class="wf-node wf-node--bim">';
  h += '<div class="wf-row">';
  h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  h += '<span class="wf-bullet wf-bullet--item"></span>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--bim">' + name + '</span>';
  if (status) h += '<span class="wf-status-pill" style="color:' + statusColor + ';border-color:' + statusColor + '33;">' + status + '</span>';
  h += '</div></div></div>';
  return h;
}

export function buildSheetRow(rev) {
  var f = rev.fields;
  var title = getFirst(f['Sheet Number and Title (from Drawing Sheet)']) || 'Untitled Sheet';
  var h = '<div class="wf-node wf-node--sheet">';
  h += '<div class="wf-row">';
  h += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
  h += '<span class="wf-bullet wf-bullet--item"></span>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--sheet">' + title + '</span></div>';
  h += '</div></div>';
  return h;
}

/* ── Discipline prefix detection (mirrors DrawingSheetList.jsx) ─────────── */
var SHEET_DISC_ORDER = [
  'General','Special General','As-Built','Architectural','Demolition',
  'Architectural Detailing','Interior Architecture','Energy','Civil',
  'Electrical','Mechanical','Structural','Landscape','Plumbing','Other',
];
function sheetDiscipline(title) {
  var m = /^([A-Za-z]+)/.exec((title || '').trim());
  var p = m ? m[1].toUpperCase() : '';
  if (p === 'FD') return 'General';
  if (p === 'SP') return 'Special General';
  if (p === 'AB') return 'As-Built';
  if (p === 'AD') return 'Architectural Detailing';
  if (p === 'EL') return 'Electrical';
  if (p === 'G')  return 'General';
  if (p === 'A')  return 'Architectural';
  if (p === 'I')  return 'Interior Architecture';
  if (p === 'S')  return 'Structural';
  if (p === 'C')  return 'Civil';
  if (p === 'M')  return 'Mechanical';
  if (p === 'L')  return 'Landscape';
  if (p === 'D')  return 'Demolition';
  if (p === 'P')  return 'Plumbing';
  return 'Other';
}

export function buildSheetDisciplineGroupsHtml(msId, sheetItems) {
  var map = {};
  for (var i = 0; i < sheetItems.length; i++) {
    var title = getFirst(sheetItems[i].fields['Sheet Number and Title (from Drawing Sheet)']) || '';
    var d = sheetDiscipline(title);
    if (!map[d]) map[d] = [];
    map[d].push(sheetItems[i]);
  }
  var h = '';
  for (var di = 0; di < SHEET_DISC_ORDER.length; di++) {
    var disc = SHEET_DISC_ORDER[di];
    if (!map[disc]) continue;
    var items = map[disc];
    var discKey = 'sec:' + msId + ':disc:' + disc;
    var collapsed = isNodeCollapsed(discKey, false);
    h += '<div class="wf-node wf-node--section wf-node--section-disc' + (collapsed ? ' wf-node--collapsed' : '') + '">';
    h += '<div class="wf-row">';
    h += '<button class="wf-triangle" data-fn="toggleCollapse" data-key="' + discKey + '">';
    h += '<span class="wf-tri-icon ' + (collapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span>';
    h += '</button>';
    h += '<button class="wf-bullet wf-bullet--section"></button>';
    h += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--section">' + disc + '</span>';
    h += '<span class="wf-prog" style="color:#7a9aaa;margin-left:8px;">' + items.length + '</span>';
    h += '</div></div>';
    if (!collapsed) {
      h += '<div class="wf-children">';
      for (var si = 0; si < items.length; si++) h += buildSheetRow(items[si]);
      h += '</div>';
    }
    h += '</div>';
  }
  return h;
}

export function buildProductionChildren() {
  var h = '';

  var sheetsInner = '';
  if (ctx.projSheetCache === null) {
    sheetsInner = '<div class="wf-loading">Loading sheets...</div>';
    loadProjectSheets();
  } else if (ctx.projSheetCache.length === 0) {
    sheetsInner = '<div class="wf-loading" style="color:#7a9aaa;">No drawing sheets</div>';
  } else {
    for (var si = 0; si < ctx.projSheetCache.length; si++) {
      var sf = ctx.projSheetCache[si].fields;
      var stitle = (sf['Sheet Number and Title'] || 'Untitled');
      var sprog = sf['Sheet Progress'] || '';
      var sprogColor = sprog === 'Complete' ? '#1D9E75' : sprog === 'In Progress' ? '#1a6fa8' : '#7a9aaa';
      sheetsInner += '<div class="wf-node wf-node--sheet"><div class="wf-row">';
      sheetsInner += '<span class="wf-triangle-spacer wf-triangle-spacer--hidden"></span>';
      sheetsInner += '<span class="wf-bullet wf-bullet--item"></span>';
      sheetsInner += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--sheet">' + stitle + '</span>';
      if (sprog) sheetsInner += '<span class="wf-status-pill" style="color:' + sprogColor + ';border-color:' + sprogColor + '33;">' + sprog + '</span>';
      sheetsInner += '</div></div></div>';
    }
  }
  h += buildSectionNode('prod', 'sheets', 'Drawing Sheets', sheetsInner, ctx.projSheetCache ? ctx.projSheetCache.length : null);

  var bimInner = '';
  if (ctx.bimCache === null) {
    bimInner = '<div class="wf-loading">Loading...</div>';
    loadBim();
  } else if (ctx.bimCache.length === 0) {
    bimInner = '<div class="wf-loading" style="color:#7a9aaa;">No BIM systems</div>';
  } else {
    for (var bi = 0; bi < ctx.bimCache.length; bi++) bimInner += buildBimRow(ctx.bimCache[bi]);
  }
  h += buildSectionNode('prod', 'bim', 'BIM Systems', bimInner, ctx.bimCache ? ctx.bimCache.length : null);

  return h;
}
